// extracted by mini-css-extract-plugin
export default {"container":"BXj5dkz4"};